const MODULE_NAME = 'UNLOCK';
const CHALLENGE_FETCH_STARTED = MODULE_NAME + 'CHALLENGE_FETCH_STARTED';
const CHALLENGE_FETCH_COMPLETED = MODULE_NAME + 'CHALLENGE_FETCH_COMPLETED';
const CHALLENGE_ANSWER_SUBMIT_STARTED = MODULE_NAME + 'CHALLENGE_ANSWER_SUBMIT_STARTED';
const CHALLENGE_ANSWER_SUBMIT_COMPLETED = MODULE_NAME + 'CHALLENGE_ANSWER_SUBMIT_COMPLETED';
const CHALLENGE_ANSWER_SUBMIT_ERROR = MODULE_NAME + 'CHALLENGE_ANSWER_SUBMIT_ERROR';

export {
  CHALLENGE_FETCH_STARTED,
  CHALLENGE_FETCH_COMPLETED,
  CHALLENGE_ANSWER_SUBMIT_STARTED,
  CHALLENGE_ANSWER_SUBMIT_COMPLETED,
  CHALLENGE_ANSWER_SUBMIT_ERROR
};
